export const commaSeparate = (string = '', maxDisplayCount) => {
  const items = string.split(', ');
  const truncatedItems = items.slice(0, maxDisplayCount);
  const truncatedItemsString = truncatedItems.join(', ');

  if (items.length > maxDisplayCount) {
    return `${truncatedItemsString}, …`;
  }
  return truncatedItemsString;
};
